export const dateMixin = {
   methods: {
      formatDisplayDate: function(date){
         let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            hours = d.getHours() + '',
            mins = d.getMinutes() + '';
         if (month.length < 2) month = '0' + month;
         if (day.length < 2) day = '0' + day;
         if (hours.length < 2) hours = '0' + hours;
         if (mins.length < 2) mins = '0' + mins;
         let formDate = [day, month, year].join('.');
         let formTime = [hours, mins].join(':');
         return formDate + " " + formTime;
      },
      formatNowInputDate: function(){
         let d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            hours = d.getHours() + '',
            mins = d.getMinutes() + '';
         if (month.length < 2) month = '0' + month;
         if (day.length < 2) day = '0' + day;
         if (hours.length < 2) hours = '0' + hours;
         if (mins.length < 2) mins = '0' + mins;
         this.newPeriod.startdate = [year, month, day].join('-');
         this.newPeriod.starttime = [hours, mins].join(':');
         return { formattedStartDate: this.newPeriod.startdate + ' ' + this.newPeriod.starttime };
      }
   }
};


// WEBPACK FOOTER //
// ./src/Banet/mixins/dateMixin.js